import HTTP from '../HTTP';

const PARAMETRAGE_URL = 'parametrages/';

export async function setAll(parametrages) {
  try {
    const response = await HTTP.post(PARAMETRAGE_URL, parametrages);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getAll() {
  try {
    const response = await HTTP.get(PARAMETRAGE_URL);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getParamAffixe2(key) {
  try {
    const response = await HTTP.get(PARAMETRAGE_URL + 'GetSettingAffixe2Async?key=' + key);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function PGetAllRegimeTvaAsync(idSociete) {
  try {
    const query = {
      query: {
        societeId: idSociete,
      },
      sorting: 'tauxTva ASC',
      skipCount: 0,
      maxResultCount: 20,
    };
    const response = await HTTP.post(`${PARAMETRAGE_URL}/PGetAllRegimeTvaAsync`, query);
    return response;
  } catch (e) {
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/api/parametrage/index.js